import { TableBody, TableCell, TableRow, Typography } from "@mui/material";

interface NoResultsFoundRowProps {
  colSpan: number;
  filterName: string;
}
export const NoResultsFoundRow = ({
  filterName,
  colSpan,
}: NoResultsFoundRowProps) => {
  return (
    <TableBody>
      <TableRow>
        <TableCell align="center" colSpan={colSpan} sx={{ py: 3 }}>
          <Typography variant="h6" paragraph>
            Not found
          </Typography>

          <Typography variant="body2">
            No results found for &nbsp;
            <strong>&quot;{filterName}&quot;</strong>.
            <br /> Try checking for typos or using complete words.
          </Typography>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};
